import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';
import { number } from 'prop-types';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic { 
    /** 便签数据 */
    public tagAllCateAndTagData: any[];
    /** 展开的节点 */
    public expandedKeys: any[] = [];
}



// WEBPACK FOOTER //
// ./src/display/platform/Network/TagTreeComponent/Modules.State.ts